import { render, staticRenderFns } from "./Device.vue?vue&type=template&id=b227cf32&scoped=true"
import script from "./Device.vue?vue&type=script&lang=js"
export * from "./Device.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./Device.vue?vue&type=style&index=1&id=b227cf32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b227cf32",
  null
  
)

export default component.exports